export default __webpack_public_path__ + "static/media/Major Rune Stone of Unholy Communion.aeef450a.jpg";